var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.visible,"opacity":_vm.opacity,"spinner-medium":"","spinner-variant":"primary","fixed":_vm.isFullPage,"no-wrap":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }